import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import { selectUser, login, logout } from './features/userSlice';
import Messenger from './Messenger';
import  Login  from './Login';
import {auth} from "./firebase";

function App() {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  useEffect(() => {
    auth.onAuthStateChanged((authUser) => {
      if(authUser) {
        //user is logged in
        dispatch(
          login({
          uid: authUser.uid,
          photo: authUser.photoURL,
          email: authUser.email,
          displayName: authUser.displayName,
        })
        );
      } else {
        //user is logged out
        dispatch(logout())
      }
    });
  }, [dispatch]);

  return <div className="app">{user ? <Messenger /> : <Login />}</div>;
}

export default App;

//start working on the css of the login page to make page look nicer
// next